import React, { useRef, useEffect, useMemo } from 'react';
import DataGrid, { Column, Label, Lookup } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, {FormRef, GroupItem, SimpleItem} from "devextreme-react/form";
import IPays from '../../models/IPays';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import { FileUploader, Gallery } from "devextreme-react";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';

interface IConfigurationPaysProps {
  isModeSelection?: boolean,
}

export default function ConfigurationPays({ isModeSelection }: IConfigurationPaysProps) {
  const paysFormDataSource = useCustomDataSource<IPays, IPays>({ path: "pays", primaryKey: "idPays" });
  const { setMainForm, selectedDataRow: selectedPays, mode,setMode, setSelectedDataRow, isFieldModifier, onFieldDataChanged } = paysFormDataSource;
  const formRef =useRef<FormRef>(null);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture)
      formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  const renderFlag = (data: any) => {
    // return <img src={"data:image/jpeg;base64, iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC"} />
    if (data?.data?.drapeau)
      return <Gallery
        disabled={true}
        // className='gestion-types-unites-image'
        dataSource={[`data:image/png;base64, ${data.data.drapeau}`]}
        noDataText=''
        width={30}
        height={30}
        showIndicator={false}
      />
    return null;
  }

  return (
    <FormListBase data={paysFormDataSource}>
      <FormListBaseGrid dataSource={paysFormDataSource.dataSource} onFocusedRowChanged={() => { if(mode === Mode.Modifier)setMode(Mode.Lecture) }}>
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-description-en"} dataField={"descriptionAnglais"} caption="Description anglaise" allowHiding={true} />
        <Column key={"grid-col-code"} dataField={"code"} caption="Code" allowHiding={false} />
        <Column key={"grid-col-drapeau"} caption="Drapeau" allowHiding={false} cellRender={renderFlag} />
      </FormListBaseGrid>
      <FormListBaseToolbar removeBlocked={true} headerText={`${selectedPays?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            {/* <div style={{ position: "relative", float: "left" }}> */}
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPays || {} as IPays} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem>
                <SimpleItem key={"frm-description"} dataField={"description"} />
                <SimpleItem key={"frm-description-en"} dataField={"descriptionAnglais"} />
                <SimpleItem key={"frm-code"} dataField={"code"} />
                <GroupItem colCount={3}>
                  <GroupItem>
                    <Label text="Drapeau" />
                    <Gallery
                      disabled={mode === Mode.Lecture}
                      className='gestion-types-unites-image'
                      dataSource={[`data:image/png;base64, ${selectedPays.drapeau}`]}
                      // dataSource={[`${currentSelected.image}`]}
                      // dataSource={[`data:image/png;base64,${photo}`]}
                      noDataText='Pas de données image'
                      width={30}
                      height={30}
                      showIndicator={false}
                    />
                  </GroupItem>
                  <SimpleItem key={"frm-uploadImg"} >
                    <FileUploader
                      disabled={mode === Mode.Lecture}
                      onValueChange={async (e) => {
                        if (e?.[0]) {
                          // if (e.value?.[0]) {
                          const file = e[0];
                          const fr = new FileReader();
                          await fr.readAsDataURL(file);
                          fr.onload = () => {
                            if (fr.result) {
                              const base64 = fr.result.toString();
                              var solution = base64.split("base64,")[1];
                              console.log(solution)
                              setSelectedDataRow((prev: IPays) => (
                                { ...prev, 'drapeau': solution }
                              ));
                            }
                          };
                        } else {
                          alert("File not selected or browser incompatible.")
                        }
                      }}
                      showFileList={false}
                      selectButtonText="Modifier"
                      labelText="" accept="image/*" uploadMode="useForm"
                    />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>
            {/* </div> */}
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedPays || {} as IPays} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase >
  );
}